import { inr } from "@/lib/serviceInvoiceReport";

const TH = "px-3 py-2 font-mono text-[10px] uppercase tracking-[0.15em] text-ink-muted text-right first:text-left";

export default function BreakdownTable({ title, rows, testId }) {
  return (
    <div className="border border-canvas-line bg-white" data-testid={testId}>
      <p className="px-3 py-2 border-b border-canvas-line font-bold text-sm">{title}</p>
      <table className="w-full text-sm">
        <thead className="bg-canvas">
          <tr><th className={TH}>Name</th><th className={TH}>Inv.</th><th className={TH}>Labour</th><th className={TH}>Spares</th><th className={TH}>Warranty</th><th className={TH}>Total</th></tr>
        </thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={6} className="px-3 py-4 text-center text-xs text-ink-muted">—</td></tr>}
          {rows.map((r) => (
            <tr key={r.name} className="border-t border-canvas-line">
              <td className="px-3 py-1.5 text-xs font-semibold">{r.name}</td>
              <td className="px-3 py-1.5 text-right font-mono text-xs">{r.count}</td>
              <td className="px-3 py-1.5 text-right font-mono text-xs">{inr(r.labour)}</td>
              <td className="px-3 py-1.5 text-right font-mono text-xs">{inr(r.spares)}</td>
              <td className="px-3 py-1.5 text-right font-mono text-xs">{inr(r.warranty_part_value)}</td>
              <td className="px-3 py-1.5 text-right font-mono text-xs font-bold">{inr(r.total_invoice_value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
